(function () {
  var SECTION_SELECTOR = '.oddit-section-main-product';
  var cleanupMap = new WeakMap();

  function initSection(section) {
    var cleanups = [];
    cleanups.push(initThumbnails(section));
    cleanups.push(initDrag(section.querySelector('.oddit-section-main-product__thumbnails'), 'oddit-section-main-product__thumbnails--dragging'));
    cleanups.push(initDrag(section.querySelector('.oddit-section-main-product__main-slider'), 'oddit-section-main-product__main-slider--dragging'));
    cleanups.push(initReviewsLink(section));
    initPurchase(section);
    cleanupMap.set(section, cleanups);
  }

  function destroySection(section) {
    var cleanups = cleanupMap.get(section);
    if (cleanups) {
      cleanups.forEach(function (fn) { if (fn) fn(); });
      cleanupMap.delete(section);
    }
  }

  function initThumbnails(section) {
    var thumbnails = section.querySelectorAll('.oddit-section-main-product__thumbnail');
    var thumbTrack = section.querySelector('.oddit-section-main-product__thumbnails');
    var slider = section.querySelector('.oddit-section-main-product__main-slider');
    var slides = section.querySelectorAll('.oddit-section-main-product__main-image');

    function centerThumb(thumb) {
      if (!thumbTrack || thumbTrack.scrollWidth <= thumbTrack.clientWidth) return;
      var trackRect = thumbTrack.getBoundingClientRect();
      var thumbRect = thumb.getBoundingClientRect();
      var offset = thumbRect.left - trackRect.left - (thumbTrack.clientWidth - thumbRect.width) / 2;
      thumbTrack.scrollTo({ left: thumbTrack.scrollLeft + offset, behavior: 'smooth' });
    }

    // Single source of truth for both directions: thumbnail click and slider scroll.
    function setActive(index) {
      thumbnails.forEach(function (t, i) {
        t.classList.toggle('oddit-section-main-product__thumbnail--active', i === index);
      });
      if (thumbnails[index]) centerThumb(thumbnails[index]);
    }

    // A click's smooth scroll passes over every slide in between; ignore those
    // scroll events so the sync below doesn't walk the rail through each one.
    var ignoreScrollUntil = 0;

    thumbnails.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        setActive(index);

        var slide = slides[index];
        if (slider && slide && slider.scrollWidth > slider.clientWidth) {
          ignoreScrollUntil = Date.now() + 600;
          slider.scrollTo({ left: slide.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
        }
      });
    });

    // Dragging/swiping the slider drives the thumbnails (all breakpoints).
    if (!slider || !slides.length) return null;

    var frame = 0;
    function onScroll() {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0;
        if (Date.now() < ignoreScrollUntil) return;
        var origin = slides[0].offsetLeft;
        var nearest = 0;
        var best = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(slide.offsetLeft - origin - slider.scrollLeft);
          if (dist < best) {
            best = dist;
            nearest = i;
          }
        });
        setActive(nearest);
      });
    }

    slider.addEventListener('scroll', onScroll, { passive: true });

    return function cleanup() {
      slider.removeEventListener('scroll', onScroll);
      if (frame) cancelAnimationFrame(frame);
    };
  }

  function initReviewsLink(section) {
    var link = section.querySelector('.oddit-section-main-product__reviews-link');
    if (!link) return null;

    function onClick(e) {
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) !== '#' || href.length < 2) return;
      var target = document.getElementById(href.slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    link.addEventListener('click', onClick);

    return function cleanup() {
      link.removeEventListener('click', onClick);
    };
  }

  function initDrag(track, DRAGGING) {
    if (!track) return null;

    var active = false;
    var moved = false;
    var startX = 0;
    var lastX = 0;

    function onPointerDown(e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (typeof e.button === 'number' && e.button !== 0) return;
      active = true;
      moved = false;
      startX = e.clientX;
      lastX = e.clientX;
      track.classList.add(DRAGGING);
    }

    function onPointerMove(e) {
      if (!active) return;
      var dx = e.clientX - lastX;
      lastX = e.clientX;
      if (Math.abs(e.clientX - startX) > 4) moved = true;
      track.scrollLeft -= dx;
    }

    function endDrag() {
      if (!active) return;
      active = false;
      track.classList.remove(DRAGGING);
    }

    function onClick(e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }

    // Without this the browser's native image drag steals the pointer mid-swipe.
    function onDragStart(e) {
      e.preventDefault();
    }

    track.addEventListener('dragstart', onDragStart);
    track.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', onClick, true);

    return function cleanup() {
      track.removeEventListener('dragstart', onDragStart);
      track.removeEventListener('pointerdown', onPointerDown);
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', endDrag);
      window.removeEventListener('pointercancel', endDrag);
      track.removeEventListener('click', onClick, true);
    };
  }

  // Variant + subscribe/one-time selection. Everything routes through render(),
  // so the hidden form inputs can never drift from what the cards show.
  function initPurchase(section) {
    var dataEl = section.querySelector('[data-product-variants]');
    if (!dataEl) return;

    var byId = {};
    JSON.parse(dataEl.textContent).forEach(function (v) {
      byId[v.id] = v;
    });

    // Two forms carry one: the add-to-cart form and the payment-terms banner.
    var variantInputs = section.querySelectorAll('[data-variant-input]');
    var planInput = section.querySelector('[data-selling-plan-input]');
    var planSelect = section.querySelector('[data-selling-plan-select]');
    var variantCards = section.querySelectorAll('.oddit-section-main-product__variant-card');
    var purchaseCards = section.querySelectorAll('[data-purchase]');
    var button = section.querySelector('[data-add-to-cart]');

    var state = {
      variantId: variantInputs[0] && variantInputs[0].value,
      subscribe: !!section.querySelector('[data-purchase="subscribe"].oddit-section-main-product__purchase-card--active')
    };

    function setText(selector, value) {
      var el = section.querySelector(selector);
      if (el && value != null) el.textContent = value;
    }

    function render() {
      var variant = byId[state.variantId];
      if (!variant) return;

      var planId = planSelect ? planSelect.value : '';
      var plan = state.subscribe ? variant.plans[planId] : null;
      var shown = plan || variant;

      variantInputs.forEach(function (input) { input.value = variant.id; });
      if (planInput) planInput.value = plan ? planId : '';

      variantCards.forEach(function (c) {
        var cardId = c.getAttribute('data-variant-id');
        var on = String(cardId) === String(variant.id);
        c.classList.toggle('oddit-section-main-product__variant-card--active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');

        var cardVariant = byId[cardId];
        if (!cardVariant) return;
        var cardPlan = state.subscribe ? cardVariant.plans[planId] : null;
        var cardPrice = cardPlan ? cardPlan.price : cardVariant.price;
        var cardCompare = cardPlan ? cardPlan.cardCompareAt : cardVariant.compareAt;
        var cardSavings = cardPlan ? cardPlan.cardSavings : cardVariant.savings;

        var cardPriceEl = c.querySelector('[data-variant-price]');
        if (cardPriceEl) cardPriceEl.textContent = cardPrice;

        var cardCompareEl = c.querySelector('[data-variant-compare]');
        if (cardCompareEl) {
          cardCompareEl.hidden = cardCompare == null;
          var cardCompareValue = c.querySelector('[data-variant-compare-value]');
          if (cardCompareValue && cardCompare != null) cardCompareValue.textContent = cardCompare;
        }

        var cardSaveEl = c.querySelector('[data-variant-save]');
        if (cardSaveEl) {
          cardSaveEl.hidden = cardSavings == null;
          if (cardSavings != null) cardSaveEl.textContent = 'Save ' + cardSavings + '%';
        }
      });

      // The subscribe card's label, badge and price always describe the subscribe
      // plan, even while One-time is the selected option. Resolve it before the
      // card loop below, which copies the active label into the subtitle.
      var subscribePlan = variant.plans[planId];
      var pct = subscribePlan && subscribePlan.savings;

      var subscribeLabel = section.querySelector('[data-subscribe-label]');
      if (subscribeLabel) {
        var prefix = subscribeLabel.getAttribute('data-prefix');
        subscribeLabel.textContent = pct == null ? prefix : prefix + ' ' + pct + '%';
      }

      var savingsBadge = section.querySelector('[data-subscribe-savings]');
      if (savingsBadge) {
        savingsBadge.hidden = pct == null;
        if (pct != null) savingsBadge.textContent = 'Save ' + pct + '%';
      }

      purchaseCards.forEach(function (c) {
        var on = (c.getAttribute('data-purchase') === 'subscribe') === state.subscribe;
        c.classList.toggle('oddit-section-main-product__purchase-card--active', on);
        var radio = c.querySelector('.oddit-section-main-product__radio');
        if (radio) radio.classList.toggle('oddit-section-main-product__radio--checked', on);
        if (on) {
          var cardLabel = c.querySelector('.oddit-section-main-product__purchase-card-label');
          if (cardLabel) setText('[data-purchase-sub]', cardLabel.textContent);
        }
      });

      setText('[data-quantity-value]', variant.title);
      setText('[data-product-price]', shown.price);
      setText('[data-onetime-price]', variant.price);
      setText('[data-onetime-daily]', variant.daily);
      setText('[data-subscribe-price]', (subscribePlan || {}).price);
      setText('[data-subscribe-daily]', (subscribePlan || {}).daily);

      var subscribeCompare = section.querySelector('[data-subscribe-compare]');
      if (subscribeCompare) {
        var subscribeCompareAt = (subscribePlan || {}).compareAt;
        subscribeCompare.hidden = !subscribeCompareAt;
        setText('[data-subscribe-compare-value]', subscribeCompareAt);
      }

      var compare = section.querySelector('[data-price-compare]');
      if (compare) {
        compare.hidden = !shown.compareAt;
        setText('[data-price-compare-value]', shown.compareAt);
      }
      var savings = section.querySelector('[data-price-savings]');
      if (savings) {
        savings.hidden = shown.savings == null;
        if (shown.savings != null) savings.textContent = 'Save ' + shown.savings + '%';
      }

      if (button) {
        button.disabled = !variant.available;
        button.setAttribute('data-variant-id', variant.id);
        button.setAttribute('data-selling-plan', plan ? planId : '');
        setText('[data-add-to-cart] [data-button-label]',
          variant.available ? 'Add to Cart • ' + shown.price : 'Sold Out');
      }

      // Lets the sticky bar follow along without duplicating the variant data.
      var detail = {
        variantId: variant.id,
        sellingPlanId: plan ? planId : '',
        planLabel: plan && subscribeLabel ? subscribeLabel.textContent : '',
        title: variant.title,
        available: variant.available,
        price: shown.price,
        compareAt: shown.compareAt
      };

      window.odditVariantState = detail;
      document.dispatchEvent(new CustomEvent('oddit:variant:change', { detail: detail }));
    }

    variantCards.forEach(function (card) {
      card.addEventListener('click', function () {
        state.variantId = card.getAttribute('data-variant-id');
        render();
      });
    });

    purchaseCards.forEach(function (card) {
      card.addEventListener('click', function () {
        state.subscribe = card.getAttribute('data-purchase') === 'subscribe';
        render();
      });
    });

    if (planSelect) planSelect.addEventListener('change', render);

    render();
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();